<template>
  <div id="app" class="test-classname">
    <app-header></app-header>
    <main-layout>
      <router-view />
    </main-layout>
  </div>
</template>

<style lang="scss">
  @import '~@assets/scss/app';

  #app {
    flex: 1 0 auto;

    &.in-gamecenter {
      background-color: #141414;
    }

    .readMode {
      background-color: $white-three;
    }
  }
</style>


<script>
import { inGamecenter, isVkPlay } from '@platform/shared';
import AppHeader from '@components/AppHeader';
import { isReadMode, PAGE_LINKS, PAGE_META } from './utils/services';

export default ({
  name: 'App',
  components: {
    AppHeader,
  },
  created() {
    if (this.$i18n.locale === 'ar_AA' || this.$route.query.lang === 'ar_AA') {
      document.dir = 'rtl';
    }

    const cookieLang = this.$cookies.get('amc_lang');

    if (cookieLang) {
      this.$root.$i18n.locale = cookieLang;
    } else if (!isVkPlay) {
      this.$root.$i18n.locale = 'en_US';
    }
  },
  watch: {
    '$i18n.locale': {
      handler: 'onLocaleUpdate',
    },
  },
  methods: {
    onLocaleUpdate() {
      if (this.$i18n.locale === 'ar_AA' || this.$route.query.lang === 'ar_AA') {
        document.dir = 'rtl';
      } else {
        document.dir = 'ltr';
      }
    },
  },
  mounted() {
    if (isReadMode) {
      const appEl = document.getElementById('app');

      appEl.classList.add('readMode');
    }

    if (inGamecenter) {
      const appEl = document.getElementById('app');

      appEl.classList.add('in-gamecenter');
    }
  },
  page: {
    link: PAGE_LINKS,
    meta: PAGE_META,
  },
});
</script>
